import * as yup from "yup";
import { UserProfileProps } from "../../shared/actions/Authentication.actions";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface Company {
  id: number;
  name: string;
  address: string;
  email: string;
  phone_number1: string;
  phone_number2?: string;
  phone_number3?: string;
  licence_type?: string;
}

export interface LoginResponse {
  refresh?: string;
  access?: string;
  user?: UserProfileProps;
  permissions?: Array<string>;
  detail?: string;
  company?: Company;
}

export const schema = yup.object().shape({
  email: yup.string().required("Email boş bırakılamaz"),
  password: yup.string().required("Şifre boş bırakılamaz"),
});
